import { Op } from "../function";

/**
 * Unlike lodash range, includes the specified end number.
 * So range(1, 10) gives you 1-10 instead of 1-9.
 */
export function range(start: number, end: number): number[] {
    if (!Number.isInteger(start)) {
        throw new Error("start must be an integer");
    }
    if (!Number.isInteger(end)) {
        throw new Error("end must be an integer");
    }

    return new Array(Math.abs(end - start) + 1).fill(start).map(start > end ? Op.SUB : Op.ADD);
}
